import React, { ReactElement } from 'react'
import getEnglishStrings from 'utils/getEnglishStrings'
import StyledMarkdown from 'components/UI/StyledMarkdown'

export default function ComponentMarkdown({
  data,
}: {
  data: Queries.DirectusData_component_markdown
}): ReactElement {
  const strings = getEnglishStrings(data?.strings)
  return <StyledMarkdown>{strings?.content}</StyledMarkdown>
}
